/**
 * Shared typography for TipTap-rendered `<table>` in editor ProseMirror and read-only HTML.
 */
export const richTextTableSx = {
  overflowX: 'auto',
  maxWidth: '100%',
  '& .tableWrapper': {
    overflowX: 'auto',
    maxWidth: '100%',
  },
  '& table': {
    borderCollapse: 'collapse',
    width: '100%',
    tableLayout: 'fixed',
    margin: '0.75em 0',
    borderSpacing: 0,
  },
  '& th, & td': {
    border: '1px solid rgba(0, 0, 0, 0.55)',
    padding: '0.35em 0.5em',
    verticalAlign: 'top',
    wordBreak: 'break-word',
  },
  '& th': {
    fontWeight: 600,
  },
  '& td p, & th p': {
    margin: '0.15em 0',
    '&:first-of-type': { marginTop: 0 },
    '&:last-child': { marginBottom: 0 },
  },
};
